import React, { useCallback } from "react";
import "./event.css";
import { useEffect, useState } from "react";
import Upcoming from "../../Components/EventPage/upcoming.jsx";
import Past from "../../Components/EventPage/past.jsx";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";

const abc = (data, setUpcoming, setPast) => {
  let Up_coming = data.filter((el) => {
    return (Date.now() < finaldate(`${el[2]} ${el[3]}`))
  })
  let P_ast = data.filter((el) => {
    return (Date.now() > finaldate(`${el[2]} ${el[3]}`))
  })

  Up_coming = Up_coming.sort(function (a, b) {
    var date1 = a[2].split("/")
    var date2 = b[2].split("/")
    if (date2[2] === date1[2]) {
      if (date1[0] === date2[0]) {
        return parseInt(date2[1]) - parseInt(date1[1])
      }
      else {
        return parseInt(date2[0]) - parseInt(date1[0])
      }
    }
    return parseInt(date2[2]) - parseInt(date1[2])
  }).reverse()
  P_ast = P_ast.sort(function (a, b) {
    var date1 = a[2].split("/")
    var date2 = b[2].split("/")
    if (date2[2] === date1[2]) {
      if (date1[0] === date2[0]) {
        return parseInt(date2[1]) - parseInt(date1[1])
      }
      else {
        return parseInt(date2[0]) - parseInt(date1[0])
      }
    }
    return parseInt(date2[2]) - parseInt(date1[2])
  })
  setUpcoming(Up_coming);
  setPast(P_ast);
}

let finaldate = (date) => {
  var d = new Date(date);
  let time = d.getTime();
  return time;
}

let Event = () => {
  const [toggle, setToggle] = useState({
    name: "React",
    showHideDemo1: true,
    showHideDemo2: false,
  })
  const [data, setData] = useState([]);
  const [Up_coming, setUpcoming] = useState([]);
  const [P_ast, setPast] = useState([]);

  const url = "https://sheets.googleapis.com/v4/spreadsheets/1xT_aIrk3p-1D5H-guczpwBk1NuT-5zh9WM8AL6hOEIw/values:batchGet?ranges=A2:U133&key=AIzaSyATGC19rqvjo4HJs8uMHFoittxEeoNViPs"

  const getData = useCallback(() => {
    // try {
    //   const res = await fetch(url);
    //   const FetchData = await res.json();
    //   console.log(FetchData);
    //   const mydata=FetchData.valueRanges[0].values;
    // } catch (error) {
    //   // console.log(error);
    // }
    if (data.length === 0) {
      fetch(url)
        .then((res) => res.json())
        .then((dat) => {
          setData(dat.valueRanges[0].values);
          abc(dat.valueRanges[0].values, setUpcoming, setPast);
        })
    }

  }, [data]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <div>
      <Navbar />
      <div className="boody">
        <br />
        <center>
          <div className="header" style={{ top: "43px" }}>
            <div className="heading">EVENTS  AND  WORKSHOPS</div>
          </div>
          <h3 className="majorsubtitle">
            Come learn, share and connect with us in person.
          </h3>
          <ul>
            <li >
              <button
                href=""
                onClick={() => setToggle({
                  name: "React",
                  showHideDemo1: true,
                  showHideDemo2: false,
                })}
              >
                Upcoming Events
              </button>
            </li>
            <li>
              <button
                href=""
                onClick={() => setToggle({
                  name: "React",
                  showHideDemo1: false,
                  showHideDemo2: true,
                })}

              >
                Past Events{" "}
              </button>
            </li>
          </ul>
        </center>
        <hr className='divider' />


        <div className='content'>{toggle.showHideDemo2 ? <Past pastevents={
          P_ast
        } /> : <Upcoming upcomingevents={
          Up_coming
        } />}</div>


      </div>
      <hr className='divider' />

      <div>
        <Footer />

      </div>
    </div>
  );

}

export default Event;
